import React from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";

import { applyQRFormDefaultValues } from "@/utils/formHelper";
import {
  isFileAblob,
  onBindImage,
  onBindSocialNetworks,
  onBindThemePicker,
} from "@/utils/qrEditorHelper";

import { qrAppsValidation } from "@/utils/validators/qr-apps";

import { QRAppsProps } from "./types";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";

import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";
import "./styles.scss";

export const QRApps = ({ data }: QRAppsProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"apps">>(QREditorContext);

  const [qrAppData, setQAppData] = React.useState<QRProps<"apps">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const omittedValues = isFileAblob(qrData.data.logoUrl)
    ? ["data.logoUrl", "data.file", "data.apple", "data.amazon", "data.google"]
    : ["data.file", "data.apple", "data.amazon", "data.google"];

  const dataAppsWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  onBindImage(dataAppsWithDefaultValues, "appsInformationLogo", omittedValues);
  onBindThemePicker(dataAppsWithDefaultValues, "appsThemePicker", omittedValues);
  onBindSocialNetworks(dataAppsWithDefaultValues, "appSocials", "appLinks", omittedValues);

  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field === "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      omittedValues
    );
  };

  React.useEffect(() => {
    setQAppData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrAppData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-apps">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataAppsWithDefaultValues}
        schema={qrAppsValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
